module.exports = __webpack_public_path__ + "assets/media/morning.a8d20461.mp3";